export const CAJA_CONTENT = {
    lessons: {
        // caja.cierres-sobres — «Cierres de turno y sobres» — roles: admin (Administración), owner (Dueño) — pantalla: "caja.historial" — práctica: no
        "caja.cierres-sobres": {
            summary: "Cómo revisar los cierres de turno de las sedes y qué significa que un cierre esté «pendiente de revisión». Cómo se sigue cada sobre de efectivo hasta que un dueño lo retira con doble PIN, dónde queda el historial de arqueos sorpresa y por qué un cierre no se reabre ni se edita nunca.",
            keyPoints: [
                "Cada cierre les llega solo por mail y push a Administración y a los dueños. En Cierres ves esperado, declarado, diferencia y el remanente que quedó para el turno siguiente; con «Sólo con diferencia» vas directo a lo que hay que mirar.",
                "El detalle de un cierre es sólo lectura: quién abrió y con cuánto, quién cerró, esperado y declarado por medio, y la nota. Un cierre es a ciegas e irreversible: no se edita ni se reabre.",
                "Un cierre queda «pendiente de revisión» hasta que alguien de Administración lo mira y toca Revisado: así sabés qué cierres ya pasaron por un par de ojos.",
                "En Sobres está la traza de cada sobre (número, monto, quién lo preparó, si sigue en sede o quién lo retiró y cuándo). El efectivo retirado del período es la plata que de verdad salió de la sede.",
                "El retiro lo registra sólo un dueño, con su PIN más el PIN de quien le entrega el sobre: dos personas, dos confirmaciones. Un sobre que pasa en sede más del plazo configurado dispara un aviso a los dueños.",
                "Cada sede tiene dos cajas: la del gimnasio (recepción) y la del kiosko, que es sólo efectivo y se abre y se cierra por turno aparte. El efectivo del kiosko nunca entra al cierre del gimnasio. En Cierres la columna Caja dice de cuál es cada turno, y en Caja → Kiosko está el historial de la caja del kiosko con su arqueo.",
                "Exportar cierres queda registrado con quién exportó y con qué filtros.",
            ],
            estimatedMin: 7,
            contentVersion: 3,
        },
        // caja.diferencias — «Diferencias y arqueos» — roles: intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "caja.diferencias" — práctica: no
        "caja.diferencias": {
            summary: "Dónde se ven todas las diferencias de caja (de apertura, de cierre, de arqueo, de lotes de posnet y dobles cobros), quién las resuelve y cómo. Cómo leer el ranking acumulado por persona y por sede para detectar patrones, y cómo funciona un arqueo sorpresa: quién lo puede pedir y qué pasa con la caja mientras se cuenta.",
            keyPoints: [
                "Toda diferencia queda con su monto, sede, responsables, estado y explicación. No se borra ni se «arregla»: se declara y se resuelve con motivo.",
                "Sólo Administración o un dueño la resuelven (justificada, descontada o asumida por la casa), siempre con motivo. Se resuelve una sola vez y no se vuelve atrás: conviene hablar primero con la persona.",
                "El ranking, que ven Administración y los dueños, ordena por monto absoluto: un sobrante no tapa un faltante. Una diferencia que se repite en la misma persona o sede es un patrón. Coordinación ve las diferencias de su alcance.",
                "El arqueo sorpresa lo inician coordinación, Administración o un dueño sobre su sede activa, eligiendo quién cuenta. Mientras dura, sólo se bloquea el efectivo: posnet, app y kiosko siguen cobrando.",
                "El arqueo es a ciegas: quien cuenta no ve el esperado; recién al declarar aparecen esperado, declarado y diferencia, que queda registrada con quién lo pidió y quién contó.",
                "Coordinación puede iniciar arqueos pero no resolver diferencias. Exportar queda registrado.",
            ],
            estimatedMin: 7,
            contentVersion: 2,
        },
        // caja.conciliacion — «Conciliación con Payway, Mercado Pago e Interbanking» — roles: admin (Administración), owner (Dueño) — pantalla: "caja.conciliacion" — práctica: sí
        "caja.conciliacion": {
            summary: "Cómo se cruza cada peso cobrado por medios electrónicos con lo que de verdad llegó: transferencias contra el banco, transferencias a la cuenta de Mercado Pago del gimnasio, lotes de posnet y débitos de Payway, y pagos de los convenios. El sistema propone coincidencias, pero el que confirma es una persona, y nada se redondea.",
            keyPoints: [
                "Primero mirá la conexión de cada cuenta: verde sana, rojo el banco no contestó, gris nunca llegaron movimientos. Caída no es «sin transferencias»: el sistema no las puede ver, y por eso no observa ni revierte ningún cobro.",
                "Buscar coincidencias propone pares por importe, fecha, referencia y CUIT, y una persona confirma o rechaza. Rechazar deja el cobro pendiente y el movimiento libre; las coincidencias dudosas no se proponen y van a mano.",
                "Un pago agrupado (por ejemplo, un grupo familiar) se concilia a mano con motivo. Si los importes no coinciden, la diferencia queda explícita como saldo a favor o deuda parcial: nunca se redondea.",
                "Una transferencia que no aparece se marca Observar (avisa a Administración y al socio); si nunca se acreditó, se revierte la habilitación. Si Interbanking no está, se importa el extracto y las líneas ilegibles se rechazan con su motivo.",
                "Mercado Pago: se concilia sola sólo la transferencia sin duda (un único socio con ese DNI y el importe exacto); las demás las resuelve una persona, e ignorar pide motivo. Payway: cupón contra cobro y lote contra banco, con débitos rechazados que se pueden reintentar. Un doble cobro el sistema lo levanta pero no elige qué hacer.",
                "Un mismo comprobante no puede respaldar dos cobros: el sistema lo rechaza y te dice a cuál está atado. Convenios: lo liquidado a SportClub y Wellhub contra lo cobrado.",
            ],
            estimatedMin: 10,
            contentVersion: 2,
        },
        // caja.cierres-sedes — «Los cierres de todas las sedes» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño), accountant_readonly (Contador, sólo lectura) — pantalla: "reportes.cierres" — práctica: no
        "caja.cierres-sedes": {
            summary: "Cómo leer el reporte de cierres de caja de las sedes que te tocan: qué declaró quien cerró, qué decía el sistema, la diferencia y si el cierre ya fue revisado. Por qué una diferencia en cero no siempre significa lo mismo, y qué se puede hacer (y qué no) a partir de lo que ves.",
            keyPoints: [
                "Cada fila es un turno cerrado: día, sede, turno, quién cerró, lo que decía el sistema, lo declarado y la diferencia. Las filas con diferencia se ven resaltadas.",
                "La columna Operación es la clave: $ 0 de diferencia con cuarenta cobros es una caja que cuadró; $ 0 sin ningún movimiento es una caja que no operó. Plata declarada sin cobros que la expliquen se avisa a Administración.",
                "La diferencia acumulada del período compensa sobrantes con faltantes. Por eso hay que mirar el detalle, cierre por cierre.",
                "Cada rol ve las sedes de su alcance: el encargado, sólo la suya; el contador, en sólo lectura.",
                "El reporte es de lectura. Marcar revisado y seguir los sobres lo hacen Administración y los dueños en Cierres y sobres; a encargado, coordinación y contador no les aparece el botón Historial de cierres.",
                "Toda exportación queda registrada con quién la hizo. Si no hubo cierres en esas fechas, el reporte lo dice: no lo muestra como un cero.",
            ],
            estimatedMin: 5,
            contentVersion: 2,
        },
    },
    questions: [
        // ── caja.cierres-sobres ─────────────────────────────────────────────────
        {
            id: "caja.cierres-sobres#1",
            lessonKey: "caja.cierres-sobres",
            prompt: "Revisando el historial ves que el cierre de ayer a la noche tiene una nota que no se entiende y un faltante. ¿Qué podés hacer sobre ese cierre?",
            options: [
                { id: "a", text: "Reabrirlo para que quien cerró vuelva a contar." },
                { id: "b", text: "Corregir lo declarado para que coincida con el esperado." },
                {
                    id: "c",
                    text: "Mirar el detalle y marcarlo como revisado.",
                },
                { id: "d", text: "Borrarlo y pedir que se cargue de nuevo con la nota bien escrita." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, el detalle de un cierre es sólo lectura: el cierre es a ciegas e irreversible, no se edita ni se reabre. Lo que hace Administración es mirarlo y tocar Revisado.",
        },
        {
            id: "caja.cierres-sobres#2",
            lessonKey: "caja.cierres-sobres",
            prompt: "Un dueño va a llevarse un sobre de la sede. ¿Cómo queda registrado el retiro?",
            options: [
                {
                    id: "a",
                    text: "El dueño pone su PIN y quien le entrega el sobre pone el suyo.",
                },
                { id: "b", text: "Quien está en recepción lo marca «retirado» con su usuario." },
                { id: "c", text: "Alcanza con que el dueño firme la planilla de papel del turno." },
                { id: "d", text: "Se registra solo cuando el dueño deposita la plata en el banco." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, el retiro lo registra un dueño desde Sobres en sede: su PIN más el de quien entrega. Es la planilla firmada de siempre pero digital: dos personas, dos confirmaciones.",
        },
        {
            id: "caja.cierres-sobres#3",
            lessonKey: "caja.cierres-sobres",
            prompt: "Querés saber cuánta plata salió de verdad de una sede este mes. ¿Qué número mirás?",
            options: [
                { id: "a", text: "La suma de lo esperado de todos los cierres del mes." },
                { id: "b", text: "El efectivo retirado del período, en Sobres." },
                { id: "c", text: "El remanente del último cierre del mes." },
                { id: "d", text: "La suma de lo declarado de todos los cierres." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, arriba de Sobres está el efectivo retirado en el período, que es la plata que de verdad salió de la sede, y aparte lo que todavía está en sede.",
        },
        {
            id: "caja.cierres-sobres#4",
            lessonKey: "caja.cierres-sobres",
            prompt: "Hay muchos cierres en la lista y poco tiempo. ¿Cómo encarás la revisión?",
            options: [
                { id: "a", text: "Esperás a que llegue el mail de fin de mes con el resumen." },
                { id: "b", text: "Marcás todos como revisados juntos para sacarlos de la lista y después mirás los sobres." },
                { id: "c", text: "Revisás sólo los de la sede central, que concentran el efectivo." },
                {
                    id: "d",
                    text: "Filtrás «Sólo con diferencia», mirás esos primero y los marcás Revisado.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, con «Sólo con diferencia» vas directo a lo que hay que mirar, y Revisado deja constancia de qué cierres ya pasaron por un par de ojos.",
        },
        // ── caja.diferencias ────────────────────────────────────────────────────
        {
            id: "caja.diferencias#1",
            lessonKey: "caja.diferencias",
            prompt: "En el ranking, una recepcionista tuvo un sobrante de $ 20.000 un día y un faltante de $ 20.000 otro. ¿Cómo lo muestra?",
            options: [
                { id: "a", text: "En cero: el sobrante compensa el faltante y la persona no aparece en el ranking." },
                { id: "b", text: "Sólo el faltante, porque el sobrante no es un problema." },
                {
                    id: "c",
                    text: "Suma los dos por monto absoluto: un sobrante no tapa un faltante.",
                },
                { id: "d", text: "Ninguno de los dos, hasta que Administración los resuelva." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, el ranking ordena por monto absoluto: sobrantes y faltantes no se cancelan. Si alguien aparece siempre arriba, ahí hay algo para conversar.",
        },
        {
            id: "caja.diferencias#2",
            lessonKey: "caja.diferencias",
            prompt: "Sos de Administración y vas a resolver un faltante de un encargado. ¿Qué conviene hacer?",
            options: [
                {
                    id: "a",
                    text: "Hablar primero con la persona y después resolverlo con motivo.",
                },
                { id: "b", text: "Marcarlo «descontada» ya y cambiarlo después si la persona explica." },
                { id: "c", text: "Borrarlo si fue un error de un día, para que no ensucie el ranking." },
                { id: "d", text: "Pedirle a coordinación que lo resuelva, que conoce la sede." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, una diferencia se resuelve una sola vez y no se vuelve atrás, siempre con motivo. Por eso conviene hablar primero con la persona y después escribir. Coordinación no resuelve diferencias.",
        },
        {
            id: "caja.diferencias#3",
            lessonKey: "caja.diferencias",
            prompt: "Iniciaste un arqueo sorpresa en la sede y llega un socio a pagar la cuota con posnet. ¿Qué pasa?",
            options: [
                { id: "a", text: "No se puede cobrar nada hasta que termine el arqueo." },
                { id: "b", text: "Se cobra normalmente: el arqueo bloquea sólo el efectivo." },
                { id: "c", text: "Se cobra, pero el arqueo se cancela y hay que empezarlo de nuevo." },
                { id: "d", text: "Hay que mandarlo a pagar por la app." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, mientras dura el arqueo sorpresa sólo se bloquea el efectivo: el posnet, la app y el kiosko siguen cobrando.",
        },
        {
            id: "caja.diferencias#4",
            lessonKey: "caja.diferencias",
            prompt: "Durante un arqueo sorpresa, quien cuenta pregunta cuánto tendría que haber en la caja. ¿Qué le muestra el sistema?",
            options: [
                { id: "a", text: "El esperado, para que sepa cuánto buscar." },
                { id: "b", text: "Sólo el esperado de efectivo, sin el de los otros medios." },
                { id: "c", text: "El esperado se lo dice quien pidió el arqueo." },
                {
                    id: "d",
                    text: "Nada: cuenta a ciegas, sin ver el esperado.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, el arqueo es a ciegas: primero se cuenta y se declara, y recién ahí se compara. Nadie ve el esperado antes de contar.",
        },
        // ── caja.conciliacion ───────────────────────────────────────────────────
        {
            id: "caja.conciliacion#1",
            lessonKey: "caja.conciliacion",
            prompt: "La conexión con una cuenta del banco aparece en rojo y no se ve ninguna transferencia de hoy. ¿Qué entendés?",
            options: [
                {
                    id: "a",
                    text: "Que el banco no contestó: el sistema no puede ver las transferencias.",
                },
                { id: "b", text: "Que hoy nadie transfirió a esa cuenta, y los cobros pendientes hay que observarlos." },
                { id: "c", text: "Que hay que observar todas las transferencias del día." },
                { id: "d", text: "Que las transferencias se concilian solas cuando vuelva." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, rojo quiere decir que el banco no contestó. Una conexión caída no significa que no hubo transferencias: el sistema no puede verlas, y por eso no observa ni revierte ningún cobro.",
        },
        {
            id: "caja.conciliacion#2",
            lessonKey: "caja.conciliacion",
            prompt: "Una familia hizo una sola transferencia por las cuotas de tres socios y le sobraron $ 3.000. ¿Cómo se concilia?",
            options: [
                { id: "a", text: "Se acepta la propuesta automática y se redondea la diferencia." },
                { id: "b", text: "Se ignora la transferencia y se cobra cada cuota en recepción." },
                {
                    id: "c",
                    text: "A mano, con motivo: lo que sobra queda como saldo a favor.",
                },
                { id: "d", text: "Se concilia contra una sola cuota y las otras dos quedan pendientes." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, un pago agrupado se concilia manualmente con motivo, y si los importes no coinciden la diferencia queda explícita como saldo a favor o deuda parcial. Nunca se redondea en silencio.",
        },
        {
            id: "caja.conciliacion#3",
            lessonKey: "caja.conciliacion",
            prompt: "En Mercado Pago entró una transferencia y hay dos socios con datos parecidos a quien transfirió. ¿Qué pasa?",
            options: [
                { id: "a", text: "El sistema la concilia con el socio que más debe." },
                {
                    id: "b",
                    text: "Queda «Para conciliar»: una persona elige el socio y las cuotas.",
                },
                { id: "c", text: "Se reparte sola entre los dos socios en partes iguales, como saldo a favor de cada uno." },
                { id: "d", text: "Se devuelve sola a quien transfirió." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, sólo se concilian solas las transferencias sin duda: un único socio con ese DNI y el importe exacto. Las demás quedan Para conciliar y las resuelve una persona.",
        },
        {
            id: "caja.conciliacion#4",
            lessonKey: "caja.conciliacion",
            prompt: "Un socio pagó en recepción y después el débito automático también le cobró. ¿Qué hace el sistema?",
            options: [
                { id: "a", text: "Le devuelve el débito automáticamente por el mismo medio en que se cobró." },
                { id: "b", text: "Lo acredita solo a la cuota del mes siguiente." },
                { id: "c", text: "Anula el cobro de recepción y deja el débito." },
                {
                    id: "d",
                    text: "Lo marca como doble cobro y lo decide una persona, con motivo.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, el sistema levanta el doble cobro pero no elige: devolver o acreditar a una cuota futura es una decisión con permiso y motivo.",
        },
        // ── caja.cierres-sedes ──────────────────────────────────────────────────
        {
            id: "caja.cierres-sedes#1",
            lessonKey: "caja.cierres-sedes",
            prompt: "Dos turnos tienen diferencia $ 0: uno con cuarenta cobros y otro que dice «sin operaciones». ¿Qué significa cada uno?",
            options: [
                { id: "a", text: "Los dos cuadraron perfecto: no hay nada que mirar." },
                { id: "b", text: "Los dos son errores de carga: un cero exacto nunca es real, hay que avisar." },
                {
                    id: "c",
                    text: "El primero cuadró; el segundo no operó: no tuvo ningún movimiento.",
                },
                { id: "d", text: "El primero no operó y el segundo cuadró." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, la columna Operación es la clave: $ 0 con cuarenta cobros es una caja que cuadró, y $ 0 sin ningún movimiento es una caja que no operó.",
        },
        {
            id: "caja.cierres-sedes#2",
            lessonKey: "caja.cierres-sedes",
            prompt: "La diferencia acumulada del mes da casi $ 0. ¿Alcanza para quedarte tranquilo?",
            options: [
                {
                    id: "a",
                    text: "No: sobrantes y faltantes se compensan; hay que mirar el detalle.",
                },
                { id: "b", text: "Sí: si la acumulada es cero, ningún turno tuvo diferencia." },
                { id: "c", text: "Sí, siempre que todos los cierres estén revisados." },
                { id: "d", text: "No, porque la acumulada no incluye los turnos de la noche ni los del fin de semana." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, en la diferencia acumulada los sobrantes y faltantes se compensan. Por eso siempre importa mirar el detalle, y tildar «Sólo con diferencia» ayuda.",
        },
        {
            id: "caja.cierres-sedes#3",
            lessonKey: "caja.cierres-sedes",
            prompt: "Sos encargado de sede y querés marcar un cierre como revisado. ¿Qué pasa?",
            options: [
                { id: "a", text: "Lo marcás desde este reporte con el botón Revisado de cada fila." },
                { id: "b", text: "Lo marcás desde Historial de cierres." },
                { id: "c", text: "Lo marcás editando la fila del cierre." },
                {
                    id: "d",
                    text: "No te toca: eso lo hacen Administración y los dueños.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, este reporte es de lectura. Marcar revisado y seguir los sobres lo hacen Administración y los dueños; si sos encargado, coordinación o contador, el botón Historial de cierres no te aparece.",
        },
        {
            id: "caja.cierres-sedes#4",
            lessonKey: "caja.cierres-sedes",
            prompt: "Ves en rojo un turno «sin operaciones atadas, con arqueo»: hay efectivo declarado pero ningún cobro. ¿Qué hacés?",
            options: [
                { id: "a", text: "Nada: si no hubo cobros, la diferencia no importa porque no se perdió ninguna plata." },
                { id: "b", text: "Le avisás a Administración: hay plata declarada sin cobros que la expliquen." },
                { id: "c", text: "Editás el cierre y ponés lo declarado en cero." },
                { id: "d", text: "Lo exportás y lo borrás del reporte." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, si aparece en rojo sin operaciones atadas pero con arqueo, hay plata declarada sin cobros que la expliquen, y eso se le avisa a Administración. El cierre no se edita.",
        },
    ],
};
//# sourceMappingURL=caja.js.map